
const getters = {
  isInitialized: state => {
    return state.isInitialized ? state.isInitialized : false
  },
  isLoading: state => {
    return state.isLoading ? state.isLoading : false
  },
  locale: state => {
    return state.locale 
  },
  apiVersion: state => {
    return state.apiVersion ? state.apiVersion : false
  }
}

export default getters
